"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPingPongMessage = exports.MessageDirection = exports.MessageType = void 0;
const common_1 = require("@augment-vir/common");
const duration_1 = require("./augments/duration");
/**
 * These ping and pong messages are used to prevent race conditions between loading the iframe,
 * listening to its messages, and posting messages, both inside of the iframe and outside of it.
 */
var MessageType;
(function (MessageType) {
    MessageType["Ready"] = "ready";
    MessageType["SendSize"] = "send-size";
    MessageType["SendScale"] = "set-scale";
    MessageType["SendScalingMethod"] = "set-scaling-method";
    MessageType["ForceSize"] = "force-size";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var MessageDirection;
(function (MessageDirection) {
    MessageDirection["FromParent"] = "from-parent";
    MessageDirection["FromChild"] = "from-child";
})(MessageDirection = exports.MessageDirection || (exports.MessageDirection = {}));
const maxTryCount = 35;
function isMessageKind(type, direction, message) {
    return message.type === type && message.direction === direction;
}
async function sendPingPongMessage({ getMessageContext, message: messageToSend, verifyData, imageUrl, }) {
    let tryCount = 0;
    let validResponseReceived = false;
    let responseMessage = undefined;
    let listenerError;
    let messagePosted = false;
    const fullMessageToSend = {
        ...messageToSend,
        direction: MessageDirection.FromParent,
    };
    const expectedMessageType = messageToSend.type;
    function responseListener(event) {
        try {
            const receivedMessage = event.data;
            if (receivedMessage.direction !== MessageDirection.FromChild) {
                return;
            }
            if (receivedMessage &&
                messagePosted &&
                isMessageKind(expectedMessageType, MessageDirection.FromChild, receivedMessage)) {
                let isDataValid = false;
                try {
                    isDataValid = verifyData ? verifyData(receivedMessage.data) : true;
                }
                catch (error) { }
                if (!isDataValid) {
                    return;
                }
                validResponseReceived = true;
                responseMessage = receivedMessage;
            }
        }
        catch (error) {
            listenerError = (0, common_1.ensureError)(error);
        }
    }
    let previousContext = getMessageContext();
    previousContext === null || previousContext === void 0 ? void 0 : previousContext.addEventListener('message', responseListener);
    const startTime = Date.now();
    while (!validResponseReceived && tryCount < maxTryCount && !listenerError) {
        await (0, common_1.wait)((0, duration_1.makeAttemptWaitDuration)(tryCount));
        const newContext = getMessageContext();
        if (newContext) {
            previousContext === null || previousContext === void 0 ? void 0 : previousContext.removeEventListener('message', responseListener);
            newContext.addEventListener('message', responseListener);
            if (newContext !== previousContext) {
                previousContext = newContext;
            }
            messagePosted = true;
            newContext.postMessage(fullMessageToSend);
        }
        tryCount++;
    }
    const attemptDuration = Date.now() - startTime;
    if (listenerError) {
        console.error({ listenerError, imageUrl, messageToSend });
        throw listenerError;
    }
    if (!validResponseReceived) {
        throw new Error(`Failed to receive response from the iframe for message '${messageToSend.type}' after '${Math.floor(attemptDuration / 1000)}' seconds for '${imageUrl}'`);
    }
    return responseMessage === null || responseMessage === void 0 ? void 0 : responseMessage.data;
}
exports.sendPingPongMessage = sendPingPongMessage;
